'use strict';

angular.module('app.exposureReportBestExposure', [])
    .directive('exposureReportBestExposureDirective', function () {
        return {
            controller: 'exposureReportBestExposureCtrl',
            templateUrl: 'app/measure/exposureReport/exposureReportBestExposure/exposureReportBestExposure.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })